import React from "react";
import CustomSelect from "../../../components/common/CustomSelect";
import AsteriskStyle from "../../../components/Form/Tooltip/AsteriskStyle";
import { FiUploadCloud } from "react-icons/fi";
import CustomButton from "../../../components/common/CustomButton";
import Images from "../../Constants/Images";
const AutoProperty = ({ onClose, isOpen, loading, onSubmit }) => {
  if (!isOpen) return null;

  const userData = [
    {
      label: "User 1",
      value: "user1",
    },
  ];
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
      <div className="bg-white rounded-[10px] shadow-xl w-[640px]   p-6 transform transition-all">
        {/* Header */}
        <div className="flex bg-slate-100 p-2 rounded-md justify-between items-center mb-6">
          <div
            id="bulk-upload-title"
            className="text-lg font-medium text-green-700"
          >
            <div className="bg- cursor-pointer flex items-center justify-center gap-2 text-base text-customGreen font-medium s w-full rounded-[10px] p-2">
              <div>{"Auto Upload"}</div>
            </div>
          </div>
          <button
            onClick={onClose}
            className="text-red-600 bg-white px-2 focus:outline-none  rounded-full p-1"
            aria-label="Close modal"
          >
            <svg
              className="w-5 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
        {!loading ? (
          <div className="flex flex-col gap-5 ">
            <div className="grid grid-cols-12 items-center">
              <label className="col-span-4 text-sm font-medium text-gray-700">
                Plot Sourced By
              </label>
              <div className="col-span-8">
                <CustomSelect options={userData} />
              </div>
            </div>

            <div className="grid grid-cols-12 items-center">
              <label className="col-span-4 text-sm font-medium text-gray-700">
                Advance Amount
              </label>
              <div className="col-span-8">
                <input
                  type="text"
                  name="plotSourcedBy"
                  maxLength={40}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md input-focus"
                  placeholder="Name"
                />
              </div>
            </div>

            <div className="grid grid-cols-12 items-center">
              <label className="col-span-4 text-sm font-medium text-gray-700">
                Contact Person Type
              </label>
              <div className="col-span-8">
                <CustomSelect options={userData} />
              </div>
            </div>

            <div className="grid grid-cols-12 items-center">
              <label className="col-span-4 text-sm font-medium text-gray-700">
                Contact Person Name
              </label>
              <div className="col-span-8">
                <input
                  type="text"
                  name="plotSourcedBy"
                  maxLength={40}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md input-focus"
                  placeholder="Name"
                />
              </div>
            </div>

            <div className="grid grid-cols-12 items-center">
              <label className="col-span-4 text-sm font-medium text-gray-700">
                Contact Phone No.
              </label>
              <div className="col-span-8">
                <input
                  type="text"
                  name="plotSourcedBy"
                  maxLength={40}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md input-focus"
                  placeholder="Name"
                />
              </div>
            </div>

            <div className="grid grid-cols-9 px-3 mt-3 gap-3 items-center">
              <div className="col-span-3 bg-slate-100 border cursor-pointer hover:bg-green-50 hover:border-green-500 rounded-[10px] p-3">
                <div className="flex  flex-col gap-3 items-center text-center">
                  <FiUploadCloud className="text-2xl text-customGreen" />
                  <label className="text-sm font-medium text-gray-700">
                    Upload Sale Deed File
                  </label>
                </div>
              </div>

              <div className="col-span-3 bg-slate-100 border cursor-pointer hover:bg-green-50 hover:border-green-500 rounded-[10px] p-3">
                <div className="flex  flex-col gap-3 items-center text-center">
                  <FiUploadCloud className="text-2xl text-customGreen" />
                  <label className="text-sm font-medium text-gray-700">
                    Upload Patta File
                  </label>
                </div>
              </div>

              <div className="col-span-3 bg-slate-100 border cursor-pointer hover:bg-green-50 hover:border-green-500 rounded-[10px] p-3">
                <div className="flex  flex-col gap-3 items-center text-center">
                  <FiUploadCloud className="text-2xl text-customGreen" />
                  <label className="text-sm font-medium text-gray-700">
                    Upload EC File
                  </label>
                </div>
              </div>
            </div>

            <CustomButton label={"Scan"} onClick={onSubmit} />
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center ">
            <img src={Images.ScanGIF} alt="" className="w-1/2" />
            <p className="text-lg font-medium text-gray-700 mt-3">
              Analyzing...
            </p>
            <div className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-300 mt-2">
              <div
                className="bg-customGreen h-2.5 rounded-full animate-progress"
                style={{ width: "100%" }}
              ></div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AutoProperty;
